module.exports = __webpack_public_path__ + "349c3131c081b39cbdad5d04bfac780e.fbx";